//import I18n from "i18n-js/index.js.erb"
import ObjectHelper from "../ObjectHelper/ObjectHelper"

var RateBuilderErrors = {
  
  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    var field_names = [
            'name', 
            'code',
            'description', 
            'check_in_time',
            'check_out_time',
    ];

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]];
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j]);
        }
      }
    }

    return err;
  },

  products: function (errors) {
    var err = [];

    if (errors && errors.products && errors.products.length) {
      for (var i = 0, ilen = errors.products.length; i < ilen; i++) {
        err.push(I18n.t('product') + ' ' + errors.products[i]);
      }
    }    

    // nested errors
    if (errors && ObjectHelper.size(errors) > 0){
      for (var i in errors) {
        if (i.indexOf('products\.') != -1) {
          var base_field = i.split('\.')[1];
          err.push(I18n.t(base_field) + ' ' + errors[i]);
        } 
      }
    }

    return err;    
  },

  seasonal_rates: function (errors) {
    var err = [];

    if (errors && errors.seasonal_rates && errors.seasonal_rates.length) {
      for (var i = 0, ilen = errors.seasonal_rates.length; i < ilen; i++) {
        err.push(I18n.t('seasonal_rate') + ' ' + errors.seasonal_rates[i]);
      }
    }    

    return err;    
  },

  billing_policy: function (errors) {
    var err = [];

    if (errors && errors.billing_policy && errors.billing_policy.length) {
      for (var i = 0, ilen = errors.billing_policy.length; i < ilen; i++) {
        err.push(I18n.t('billing_policy') + ' ' + errors.billing_policy[i]);
      }
    }  

    // nested errors
    if (errors && ObjectHelper.size(errors) > 0){
      for (var i in errors) {
        if (i.indexOf('billing_policy\.') != -1) {
          var base_field = i.split('\.')[1];
          err.push(I18n.t(base_field) + ' ' + errors[i]);
        }
      }
    }

    return err;    
  },

  guest_types: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.guest_types && errors.guest_types.length) {
      for (var i = 0, ilen = errors.guest_types.length; i < ilen; i++) {
        err.push(errors.guest_types[i]);
      }
    }    

    return err;    
  },

  room_types: function (errors) {
    var err = [];

    if (errors && errors.room_types && errors.room_types.length) {
      for (var i = 0, ilen = errors.room_types.length; i < ilen; i++) {
        err.push(I18n.t('room_types_enabled_rate'));
      }
    }    

    return err;    
  },

  taxes_and_fees: function (errors) {
    var err = [];

    if (errors && errors.rate_taxes && errors.rate_taxes.length) {
      for (var i = 0, ilen = errors.rate_taxes.length; i < ilen; i++) {
        err.push(I18n.t('tax') + ' ' + errors.rate_taxes[i]);
      }
    }    

    if (errors && errors.rate_fees && errors.rate_fees.length) {
      for (var i = 0, ilen = errors.rate_fees.length; i < ilen; i++) {
        err.push(I18n.t('fee') + ' ' + errors.rate_fees[i]);
      }
    }    

    return err;    
  },

};

export default RateBuilderErrors